/** Frontend port of backend/billing.py's is_lesson_unlocked / is_free_trial_lesson.
 * Keep in sync with billing.py — the backend is the source of truth and enforces
 * this server-side; these helpers are for display/UX only. */

export function isFreeTrialLesson(lesson) {
  return lesson.term === 1 && lesson.week === 1 && (lesson.day === 1 || lesson.day === 2);
}

/** Mirrors billing.py's is_lesson_unlocked. `entitlements` should already be
 * scoped to the relevant child (the backend scopes by child_name via the DB
 * query before calling is_lesson_unlocked; do the same here). */
export function isUnlocked(entitlements, lesson, unlimitedAccess) {
  if (unlimitedAccess) return true;
  if (isFreeTrialLesson(lesson)) return true;
  const year = lesson.year ?? 5;
  return entitlements.some(e => {
    if (e.status !== 'active' || e.subject !== lesson.subject) return false;
    if ((e.year_level ?? 5) !== year) return false;
    const plan = e.plan ?? 'year_pass';
    if (plan === 'year_pass') return lesson.term <= (e.unlocked_through_term ?? 4);
    if (plan === 'weekly') return e.term === lesson.term && e.week === lesson.week;
    return false;
  });
}

/** "Owns everything" check — mirrors create_checkout's has_full_access rule in
 * billing.py: an active year_pass (or legacy, plan absent) entitlement for
 * this subject/year. `entitlements` should already be scoped to the child. */
export function hasFullAccess(entitlements, subject, unlimitedAccess, yearLevel = 5) {
  if (unlimitedAccess) return true;
  return entitlements.some(e =>
    e.subject === subject && e.status === 'active' &&
    (e.year_level ?? 5) === yearLevel && (e.plan ?? 'year_pass') === 'year_pass'
  );
}
